import { apiGet, apiPost, apiPatch } from '../_common';

export default {
  create(request) {
    return apiPost('/magenta/influencer', request).then(result => result.response);
  },
  batchInsert(request) {
    return apiPost('/magenta/influencer/batch', request).then(result => result.response);
  },
  update(id, request) {
    return apiPatch(`/magenta/influencer/${id}`, request).then(result => result.response);
  },
  batchUpdate(request) {
    return apiPatch(`/magenta/influencer/batch`, request).then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/influencer', query).then(result => result.response);
  },
  getInfluencerById(id) {
    return apiGet(`/magenta/influencer/${id}`).then(result => result.response);
  },
};

export const types = {
  'colaborador': 'Colaborador',
  'seeding': 'Seeding',
  'afiliado': 'Afiliado',
  'ugc': 'UGC',
  'publi': 'Publi',
}
